// src/config.js
//export const API_BASE_URL = 'https://localhost:7299'; // Replace with your actual API base URL
//export const SOCIAL_FRONTEND_URL = 'http://social.local.buildstart.au:3001';

export const API_BASE_URL = 'https://api.buildstart.au';
export const SOCIAL_FRONTEND_URL = 'https://social.buildstart.au';




